import { MDSNotePreviewContainerVariant } from "@/mds/components/note-preview-container/note-preview-container.types";
import { MDSTheme } from "@/mds/themes/theme";
import styled from "@emotion/styled";

const PREVIEW_HEIGHT = "300px";
export const FOOTER_HEIGHT = "67px";

const getBorderColor = ({
  theme,
  variant,
  isHover,
  isActive,
}: {
  theme: MDSTheme;
  variant?: MDSNotePreviewContainerVariant;
  isHover?: boolean;
  isActive?: boolean;
}) => {
  if (variant !== MDSNotePreviewContainerVariant.Flat) {
    return theme.colors.border.default;
  }

  if (isHover || isActive) {
    return theme.colors.border.default;
  }

  return theme.colors.border.default;
};

const getBoxShadow = ({
  theme,
  variant,
  isHover = false,
  isActive = false,
}: {
  theme: MDSTheme;
  variant?: MDSNotePreviewContainerVariant;
  isHover?: boolean;
  isActive?: boolean;
}) => {
  if (variant !== MDSNotePreviewContainerVariant.Flat) {
    return theme.shadows.surface;
  }

  if (isActive) {
    return theme.shadows.surface;
  }

  if (isHover) {
    return theme.shadows.surface;
  }

  return "none";
};

export const StyledNotePreviewContainer = styled.div<{
  width?: string;
  variant?: MDSNotePreviewContainerVariant;
  onClick?: React.MouseEventHandler<HTMLDivElement>;
}>`
  background-color: ${({ theme }) => theme.colors.surface.preview};
  border-radius: ${({ theme }) => theme.borderRadius.xlarge};
  box-shadow: ${({ theme, variant }) =>
    variant === MDSNotePreviewContainerVariant.Flat ? "none" : theme.shadows.surface};
  border: 1px solid ${({ theme }) => theme.colors.border.default};
  height: ${PREVIEW_HEIGHT};
  user-select: text;
  width: ${({ width }) => width || "400px"};
  max-width: calc(100vw - 60px);
  cursor: ${({ onClick }) => (onClick ? "pointer" : "default")};

  &:hover {
    box-shadow: ${({ theme, variant }) => getBoxShadow({ theme, variant, isHover: true })};
  }

  &:active {
    border-color: ${({ theme, variant }) => getBorderColor({ theme, variant, isActive: true })};
    box-shadow: ${({ theme, variant }) => getBoxShadow({ theme, variant, isActive: true })};
  }

  overflow: ${({ variant }) =>
    variant === MDSNotePreviewContainerVariant.Flat ? "hidden" : "auto"};
  scrollbar-width: none;

  --extra-padding-left: 0px;
`;

export const StyledContentArea = styled.div<{ shouldScroll: boolean }>`
  height: calc(${PREVIEW_HEIGHT} - ${FOOTER_HEIGHT});
  overflow-y: ${({ shouldScroll }) => (shouldScroll ? "auto" : "hidden")};
  scrollbar-width: none;

  &::-webkit-scrollbar {
    display: none;
  }
`;

export const StyledContentPadding = styled.div`
  height: ${({ theme }) => theme.spacing["2"]};
`;
